module.exports = __webpack_public_path__ + "img/qoala-logo.a61a908.png";